import React from 'react';
import { GuestTextComponentFragment } from '@graphql/generated';
import { Flex } from '@withjoy/joykit';
import { pxToRem } from '@withjoy/joykit/theme';
import { RichTextEditorGlobalStyle } from '@withjoy/joykit/components/RichTextEditor/RichTextEditor.styles';

interface RichTextProps {
  isFirstItem?: boolean;
  richTextComponentData: GuestTextComponentFragment;
}

export const RichText: React.FC<RichTextProps> = ({ isFirstItem, richTextComponentData }) => {
  return (
    <Flex maxWidth={pxToRem(470)} textAlign="left">
      {isFirstItem && <RichTextEditorGlobalStyle />}
      <Flex width="100%" className="jodit" flexDirection="column" dangerouslySetInnerHTML={{ __html: richTextComponentData.text || '' }} />
    </Flex>
  );
};
